import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Field, reduxForm} from 'redux-form';
import {Button} from "reactstrap";
import {CheckBoxField, InputField} from "../../../validation/ReduxFormInput";
import {handleQualifyRoommateGroup, handleDeferRoommateGroup} from "../actions/applicants";
import {hideModal} from "../../../store/actions/display";
import {FormAsyncButton} from "../../../components/controls/buttons/AsyncButton";

class OwnerApplicationDecisionForm extends Component {
    render() {
        const {handleSubmit, _handleQualifyRoommateGroup, _handleDeferRoommateGroup, confirmMode, submitting} = this.props;

        return (
            <div className="center">
                <form onSubmit={confirmMode === 'qualify' ? handleSubmit(_handleQualifyRoommateGroup) : handleSubmit(_handleDeferRoommateGroup)}>
                    <Field name={confirmMode === 'qualify' ? 'qualification_message' : 'deferral_message'}
                           label="This message will be sent with your decision"
                           placeholder={
                               confirmMode === 'qualify'
                               ?
                               "Add a custom message here. This is typically where you would put instructions for the rest of your process."
                               :
                               "Add a custom message here. This is usually something along the lines of 'Thanks for applying! Please apply again next time.' (feel free to strike that last part)"
                            }
                           component={InputField}
                           type="textarea"/>
                    <Field name="save_message"
                           label={"Save this as my default " + (confirmMode === 'qualify' ? 'qualification' : 'deferral') + " message"}
                           component={CheckBoxField}/>

                    <Button style={{margin: '0 .5em'}} outline onClick={() => this.props._hideModal('confirm_roommate_group_modal_' + this.props.roommateGroup.id)}>Cancel</Button>
                    <FormAsyncButton acting={submitting}
                                     style={{margin: '0 .5em'}}
                                     type="submit"
                                     color={confirmMode === 'qualify' ? 'success' : 'danger'}
                                     outline>
                        {confirmMode === 'qualify' ? 'Qualify' : 'Defer'}
                    </FormAsyncButton>
                </form>
            </div>
        );
    }
}

OwnerApplicationDecisionForm.propTypes = {
    ids: PropTypes.object.isRequired,
    roommateGroup: PropTypes.object.isRequired,
    confirmMode: PropTypes.string.isRequired,
};

const validate = (values) => {
    const errors = {};
    values.qualification_message === "" && (errors.qualification_message = 'Required');
    values.deferral_message === "" && (errors.deferral_message = 'Required');
    return errors;
};

OwnerApplicationDecisionForm = reduxForm({
    form: 'application_decision',
    enableReinitialization: true,
    validate
})(OwnerApplicationDecisionForm);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, props) => ({
    _handleQualifyRoommateGroup(data) {
        return dispatch(handleQualifyRoommateGroup(props.ids.prop_id, props.ids.listing_id, props.roommateGroup.id, data));
    },
    _handleDeferRoommateGroup(data) {
        return dispatch(handleDeferRoommateGroup(props.ids.prop_id, props.ids.listing_id, props.roommateGroup.id, data));
    },
    _hideModal(id) {
        return dispatch(hideModal(id));
    }
});

//Get initial form values from state
OwnerApplicationDecisionForm = connect(state => {
        let initial = Object.assign({}, {
            qualification_message: state.owner.acceptance_message,
            deferral_message: state.owner.rejection_message
        });

        return {
            initialValues: initial
        };
    }
)(OwnerApplicationDecisionForm);

export default connect(mapStateToProps, mapDispatchToProps)(OwnerApplicationDecisionForm);




// WEBPACK FOOTER //
// ./src/containers/owner/applications/OwnerApplicationDecisionForm.js